/**
 * Created by olga on 21.09.2026
 */

const GeneratorBoosterComponentView = function (component, unitView) {
    this.component = component;
    this.unitView = unitView;

    this.dimmed = [];
    this.undimmed = [];
    this.targetAnimations = [];
};

GeneratorBoosterComponentView.prototype.highlightDrag = function () {
    this.unHighlightDrag();

    Merge2.current.field.iterateUnits((x, y, unit) => {
        if (unit === this.component.unit) {
            return;
        }

        const unitView = unit.onGetView();
        if (!unitView) {
            return;
        }

        if (this.component.isApplicable(unit)) {
            this.createTargetAnimation(unitView);

            const generator = unit.findComponent(Merge2Generator);
            generator.setDimmingDisabled(true);
            this.undimmed.push(unit);
            return;
        }

        if (!this.component.unit.isMergeable(unit) && !unit.isGrounded()) {
            unitView.setImageColor(GeneratorBoosterComponentView.DIMMED_COLOR);
            this.dimmed.push(unit);
        }
    });
};

GeneratorBoosterComponentView.prototype.createTargetAnimation = function (unitView) {
    const glow = new cleverapps.Spine(bundles.merge_animations.jsons.booster_target_glow_json);
    glow.setAlignment({
        x: { align: "center" },
        y: { align: "center" }
    });
    glow.setAnimation(0, "animation", true);
    unitView.addChild(glow, -1);

    this.targetAnimations.push(glow);
};

GeneratorBoosterComponentView.prototype.unHighlightDrag = function () {
    const dimmed = this.dimmed;
    this.dimmed = [];

    dimmed.forEach((unit) => {
        const unitView = unit.onGetView();
        if (unitView) {
            unitView.restoreColor();
        }
    });

    const targetAnimations = this.targetAnimations;
    this.targetAnimations = [];

    targetAnimations.forEach((animation) => {
        animation.removeFromParent();
    });

    const undimmed = this.undimmed;
    this.undimmed = [];

    undimmed.forEach((unit) => {
        const generator = unit.findComponent(Merge2Generator);
        if (generator) {
            generator.setDimmingDisabled(false);
        }
    });
};

GeneratorBoosterComponentView.prototype.clearAnimations = function () {
    this.unHighlightDrag();
};

GeneratorBoosterComponentView.DIMMED_COLOR = new cc.Color(150, 150, 150, 255);
